import { Avatar } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { StyledHeader } from "./Style";

import { useDispatch, useSelector } from "react-redux";
import { selectApp, selectAuth, setDrawer } from "@redux";
import { Link } from "react-router-dom";
import { UserOutlined } from "@ant-design/icons";
import { SharedIconButton } from "../shared";
import { MenuIcon, RefreshIcon } from "../icons";
const style = {
  background: "rgb(240 109 36 / 39%)",
  border: 0,
  borderRadius: "6px",
  height: "33px",
  width: "33px",
};
const btnStyle = { border: 0 };
interface IProps {
  title?: string;
}
const placeholder = "Title";
export const ComponentHeader = ({ title }: IProps) => {
  const { t } = useTranslation();
  const { auth } = useSelector(selectAuth);
  const { mobile, drawer } = useSelector(selectApp);
  const dispatch = useDispatch();
  const handleReload = () => window.location.reload();
  const handleDrawer = async () => await dispatch(setDrawer(!drawer));
  const avatarSize = mobile ? 33 : 45;
  return (
    <StyledHeader className="header" theme={"light"}>
      {mobile && (
        <SharedIconButton
          size="small"
          onClick={handleDrawer}
          icon={<MenuIcon />}
          style={btnStyle}
        />
      )}
      <h4>{title || placeholder}</h4>
      <div className="profile">
        {!mobile && (
          <div>
            <p>{t("page.welcome")}</p>
            <Link to={"/"}>{auth?.email}</Link>
          </div>
        )}
        <div>
          <Avatar size={avatarSize} src={auth?.image} icon={<UserOutlined />} />
        </div>
        {!mobile && (
          <div>
            <SharedIconButton onClick={handleReload} style={style} icon={<RefreshIcon />} />
          </div>
        )}
      </div>
    </StyledHeader>
  );
};
